import request from '@/utils/request'
const apiPath = '/cust/customerRegistrationPay'
const customerRegistrationPayApi = {
  /**
   * 新增修改【客户报名付款凭证】
   */
  create(data) {
    return request.post(`${apiPath}`, data)
  },
  update(data) {
    return request.put(`${apiPath}/update2`, data)
  },
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  /**
   * 查询【客户报名付款凭证】
   */
  fetchList(query) {
    return request.get(`${apiPath}`, { params: query })
  },
}
export default customerRegistrationPayApi
